import React, { useEffect } from 'react';
import { initMetaPixel } from './utils/metaPixel';
import { OfferBanner } from './components/OfferBanner';
import { HeroSection } from './components/HeroSection';
import { ExampleBlock } from './components/ExampleBlock';
import { OpeningHook } from './components/OpeningHook';
import { ProblemSection } from './components/ProblemSection';
import { FailedAttempts } from './components/FailedAttempts';
import { UniqueMethod } from './components/UniqueMethod';
import { WhatYouGet } from './components/WhatYouGet';
import { HowItWorks } from './components/HowItWorks';
import { WhoIsThisFor } from './components/WhoIsThisFor';
import { ProofSection } from './components/ProofSection';
import { Testimonials } from './components/Testimonials';
import { FAQSection } from './components/FAQSection';
import { BonusSection } from './components/BonusSection';
import { OfferBlock } from './components/OfferBlock';
import { Footer } from './components/Footer';
import { SocialProofNotification } from './components/SocialProofNotification';
import { ResultsSection } from './components/ResultsSection';
import { MidPageCTA } from './components/MidPageCTA';
export function App() {
  useEffect(() => {
    document.title = 'Padres separados | Clave de paz';
    initMetaPixel();
  }, []);
  return <div className="min-h-screen w-full bg-navy font-sans text-slate-100 selection:bg-red-200 selection:text-red-900 pt-16 sm:pt-12" data-id="element-0">
      <OfferBanner data-id="element-1" />
      <SocialProofNotification data-id="element-2" />
      <HeroSection data-id="element-3" />
      <ExampleBlock data-id="element-4" />
      <OpeningHook data-id="element-5" />
      <ResultsSection data-id="element-6" />
      <MidPageCTA data-id="element-7" />
      <ProblemSection data-id="element-8" />
      <FailedAttempts data-id="element-9" />
      <MidPageCTA data-id="element-10" />
      <UniqueMethod data-id="element-11" />
      <WhatYouGet data-id="element-12" />
      <BonusSection data-id="element-13" />
      <OfferBlock data-id="element-14" />
      <HowItWorks data-id="element-15" />
      <WhoIsThisFor data-id="element-16" />
      <MidPageCTA data-id="element-17" />
      <ProofSection data-id="element-18" />
      <Testimonials data-id="element-19" />
      <MidPageCTA data-id="element-20" />
      <FAQSection data-id="element-21" />
      <Footer data-id="element-22" />
    </div>;
}